'use strict';


export const isLoggedIn = state => !!state.user;

//=================================================================================================================

export const userID = state => state.user ? state.user.id : null;

//=================================================================================================================

export const username = state => state.user ? state.user.username : null;

//=================================================================================================================

export const disclaimerAccepted   = state => state.disclaimerAccepted;
export const disclaimerAcceptedAt = state => state.user && state.user.disclaimerAcceptedAt;
